export default __webpack_public_path__ + "static/media/vuesax-linear-profile.eeac61a0.svg";